import { isDate, isObject, isString } from './type-utils';

/**
 * Compares two dates for sorting
 * @param {Date} a
 * @param {Date} b
 * @returns {number}
 */
export function compareDate(a, b) {
  a = a && a.getTime ? a.getTime() : 0;
  b = b && b.getTime ? b.getTime() : 0;
  return a === b ? 0 : a > b ? -1 : 1;
}

export function dateNullOrBefore(d, when = new Date()) {
  return !d || d <= when;
}

export function dateNullOrAfter(d, when = new Date()) {
  return !d || d >= when;
}

const _dateMatcher =
  /^\d{4,6}(-\d\d){2}(T\d\d(:\d\d){0,2}(\.\d{3})?(Z?([-+]\d\d:\d\d)?)?)?$/;

/**
 * Returns the ISO string of the date if we are passed a date or valid date string
 * @param {*} d
 * @return {string|null} ISOString or null if not passed in a date
 */
export function toISOString(d) {
  if (isDate(d)) {
    return d.toISOString();
  } else if (isString(d) && _dateMatcher.test(d)) {
    return new Date(d).toISOString();
  }
  return null;
}

/**
 * Walks an object tree and replaces strings that look like ISO8601 dates and timestamps
 * with actual Date objects
 *
 * @param data Anything for input
 * @returns {*} Output with date strings replaced with dates
 */
export function parseDates(data) {
  if (!isObject(data)) return data;

  angular.forEach(data, function (val, key) {
    if (isString(val) && _dateMatcher.test(val)) {
      try {
        data[key] = new Date(val);
      } catch (e) {} // ignoring date errors is acceptable
    } else if (isObject(val)) {
      parseDates(val);
    }
  });

  return data;
}

const timeBrackets = [
  [1000, 'ms'],
  [60, 's'],
  [60, 'm'],
  [24, 'h'],
];

export function msToRoundedTime(ms) {
  let t = ms;
  for (let [count, unit] of timeBrackets) {
    if (t <= count - 1) return Math.round(t) + unit;
    t = t / count;
  }
  return Math.round(t) + 'd';
}

export function roundToMinutes(ms) {
  return Math.round(ms / 60000) * 60000;
}
